import React from "react";
import DataGrid from '@dataGrid';
import GridConfig from "./gridConfig";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import StatusBar from '@dataGrid/components/StatusBar';
import { isEqual } from "lodash/lang";
import TerminalOnboardGridHeader from "./gridHeader";
const styles = (theme) => ({
  dataGrid: {
    minHeight: 150,
    height: 180,
    maxHeight: 240,
    border: `1px solid ${theme.AppBGColor}`,
    '& .ag-theme-material .ag-body-horizontal-scroll': {
      borderWidth: '0px'
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: "100%",
    },
    '& .statusBar': {
      display: 'none'
    }
  },
  terminalSubModulePart: {
    borderRight: `1px solid ${theme.AppBGColor}`,
    height: '100%'
  },
  terminalPointModuleContainer: {
    padding: '0px 18px 32px 18px',
    height: `calc(100% - 50px)`,
    boxSizing: 'border-box'
  },
  terminalPointContent: {
    borderColor: theme.AppBGColor,
    borderStyle: 'solid',
    borderWidth: '1px',
    boxSizing: 'border-box',
    height: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    '& .statusBar': {
      display: 'block'
    }
  }
});

class OnboardTerminalGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
    this.state = {
      selectedTerminals: [],
      isOnboardTerminalSelectOnGrid: false,
      quickFilterText: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.selectedTerminals, this.state.selectedTerminals)) {
      this.updateSelection();
    }
  }

  updateSelection = () => {
    if (this.gridApi) {
      const nodesToSelect = [];
      this.gridApi.forEachNode((node) => {
        if (this.props.selectedTerminalIds?.includes(node.data.terminalId)) {
          nodesToSelect.push(node);
        }
      });
      if (nodesToSelect.length > 0) {
        this.gridApi.deselectAll();
        this.gridApi.setNodesSelected({
          nodes: nodesToSelect,
          newValue: true,
        });
        nodesToSelect.forEach((node) => {
          this.gridApi.ensureNodeVisible(node);
        });
      }
    }
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  constructStatusBar = () => {
    const totalOnboardTerminal = this.props.data?.length || 0;
    const statusBarData = [
      {
        label: totalOnboardTerminal + " Terminals",
        filterCondition: "",
      },
    ];
    return statusBarData;
  };

  onCellFocused = (params) => {
    if (this.props.isTerminalFormOpen) {
      if (!params.event.ctrlKey || this.state.selectedTerminals) {
        this.setState({
          isOnboardTerminalSelectOnGrid: true,
        });
      }
    }
  };
  onSelectionChanged = () => {
    if (this.props.terminalSelectedOnGrid && this.gridApi) {
      const selectedTerminals = this.gridApi.getSelectedRows();
      this.props.terminalSelectedOnGrid(selectedTerminals);
      this.setState({ selectedTerminals: selectedTerminals });
    }
  };
  
  updateQuickFilterText = (value) => {
    this.setState({
      quickFilterText: value,
    });
  };

  render() {
    const { config } = this.gridConfig;
    const {
      classes,
      error,
      data,
      onBoardTerminalFormOpen,
      isTerminalFormOpen,
    } = this.props;
    const { selectedTerminals } = this.state;
    return (
      <div className={classes.terminalSubModulePart}>
        <div className={classes.terminalPointModuleContainer}>
          <TerminalOnboardGridHeader
            gridApi={this.gridApi}
            selectedTerminals={selectedTerminals}
            isTerminalFormOpen={isTerminalFormOpen}
            onBoardTerminalFormOpen={onBoardTerminalFormOpen}
            updateQuickFilterText={this.updateQuickFilterText}
          />
          <div className={`${classes.dataGrid} ${classes.terminalPointContent}`}>
            <DataGrid
              columnDefs={config.columns}
              config={config}
              enableFilter={config.enableFilter}
              enableSorting={config.enableSorting}
              rowSelection={config.rowSelection}
              rowDeselection={config.rowDeselection}
              rowData={data}
              onGridReady={this.onGridReady}
              onSelectionChanged={this.onSelectionChanged}
              onRowDataUpdated={this.updateSelection}
              suppressRowClickSelection={isTerminalFormOpen}
              onCellMouseDown={this.onCellFocused}
              quickFilterText={this.state.quickFilterText}
              panelLabel={(filteredData) => (
                <StatusBar
                  data={this.constructStatusBar(filteredData)}
                  filterGridData={this.updateGridData}
                />
              )}
              showErrorMessage={error}
              getRowId={(params) => params.data.terminalCode}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default compose(withStyles(styles), withSnackbar)(OnboardTerminalGrid);
